import React, { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate } from 'react-router-dom';

// @mui
import {
  Box,
  Divider,
  Typography,
  Stack,
  MenuItem,
  Avatar,
  IconButton,
  Popover
} from '@mui/material';

import { logout } from "../../../actions/auth";

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const [open, setOpen] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user: currentUser } = useSelector((state) => state.auth);

  const handleOpen = (event) => setOpen(event.currentTarget);

  const logOut = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);

  const handleClose = () => setOpen(null);

  const handleLogout = () => {
    setOpen(null);

    // 🔥 očisti localStorage (ključni fix)
    localStorage.removeItem("user");

    // opcionalno: očisti Redux state
    logOut();

    // 🔥 redirect sa full reload (bez bugova)
    window.location.href = "/login";
  };

  // 🔥 idi na change password
  const handleGoToSettings = () => {
    setOpen(null);
    navigate("/settings/change-password");
  };

  const getInitials = (name) => {
    if (!name) return "?";
    return name.substring(0, 2).toUpperCase();
  };

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  return (
    <>
      {/* AVATAR BUTTON */}
      <Box sx={{ position: "relative" }}>
        <IconButton
          onClick={handleOpen}
          sx={{
            p: 0,
            ...(open && {
              '&:before': {
                zIndex: 1,
                content: "''",
                width: '100%',
                height: '100%',
                borderRadius: '50%',
                position: 'absolute',
                bgcolor: '#00122E',
              },
            }),
          }}
        >
          <Avatar
            sx={{
              bgcolor: "#3949ab",
              width: 36,
              height: 36,
              fontSize: "0.9rem"
            }}
          >
            {getInitials(currentUser.username)}
          </Avatar>
        </IconButton>

        {/* 🟢 ONLINE DOT */}
        <Box
          sx={{
            position: "absolute",
            bottom: 2,
            right: 2,
            width: 10,
            height: 10,
            borderRadius: "50%",
            backgroundColor: "#4caf50",
            border: "2px solid #001536"
          }}
        />
      </Box>

      {/* POPOVER */}
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 200,
            borderRadius: "12px"
          },
        }}
      >
        {/* USER INFO */}
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {currentUser.id}
          </Typography>
          <Typography variant="subtitle2" noWrap>
            {currentUser.username}
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.7 }} noWrap>
            {currentUser.email}
          </Typography>
        </Box>

        <Divider />

        {/* SETTINGS */}
        <MenuItem
          onClick={handleGoToSettings}
          sx={{
            m: 1,
            borderRadius: "8px",
            fontWeight: 500,
          }}
        >
          ⚙️ Change Password
        </MenuItem>

        {/* LOGOUT */}
        <MenuItem
          onClick={handleLogout}
          sx={{
            m: 1,
            borderRadius: "8px",
            color: "#ff5252",
            fontWeight: 500,
            '&:hover': {
              backgroundColor: "rgba(255,82,82,0.1)"
            }
          }}
        >
          🔓 Logout
        </MenuItem>
      </Popover>
    </>
  );
}